var _rect, _rect2, _rect3, _rect4, _rect5, _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFundStructure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#F8F9FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 24,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#6741C6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 24,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#6741C6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 76,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#6741C6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 76,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#6741C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 24V16H82V24",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 52V76",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 52V76",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82 52V76",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26 64H102",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 6,
    fill: "white",
    stroke: "#6741C6",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 64,
    r: 6,
    fill: "white",
    stroke: "#6741C6",
    strokeWidth: 3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 82,
    cy: 64,
    r: 6,
    fill: "white",
    stroke: "#6741C6",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundStructure);
export default __webpack_public_path__ + "static/media/fund-structure.3f79a9ac53bd057a5fb013bbe23bebb7.svg";
export { ForwardRef as ReactComponent };